import { Token } from '../model';
import type { TokenRegister } from './types';

export const getYbETHToken: TokenRegister = (desiredNetwork, sdks) => {
  return {
    type: Token.ybETH,
    symbol: 'ybETH',
    addressL1: sdks.L1.getContractAddress('YbETH'),
    addressL2: sdks.L2.getContractAddress('YbETH'),
    addressCronosEvm: '',
    decimals: 18,
    displayDecimals: 6,
    Icon: () => null,
  };
};
